<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const authStore = useAuthStore()
const { t } = useI18n()

const googleShopUrl = authStore.initData?.google_shop_url || ''
const appStoreUrl = authStore.initData?.app_store_url || ''

const openUrl = (url: string) => {
  if (url) {
    window.open(url, '_blank')
  }
}

const handleLogout = () => {
  authStore.logout()
  router.push({ name: 'login' })
}
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-6">
    <div class="max-w-lg w-full text-center">
      <div class="bg-white rounded-lg shadow-sm p-8">
        <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 mb-6">
          <svg class="h-8 w-8 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
          </svg>
        </div>

        <h1 class="text-2xl font-bold text-gray-900 mb-4">{{ t('forceUpdate.title') }}</h1>

        <p class="text-gray-600 mb-8">
          {{ t('forceUpdate.message') }}
        </p>

        <div class="flex flex-col gap-3">
          <button
            v-if="googleShopUrl"
            @click="openUrl(googleShopUrl)"
            class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            {{ t('forceUpdate.goToGoogleStore') }}
          </button>

          <button
            v-if="appStoreUrl"
            @click="openUrl(appStoreUrl)"
            class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            {{ t('forceUpdate.goToAppStore') }}
          </button>

          <button
            @click="handleLogout"
            class="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors font-medium"
          >
            {{ t('forceUpdate.logout') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
